import { EventType } from "@/global/store/data/types";
import { createState } from "@/global/store/zustand_store";
import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { eventsState } from "@/global/store/data/purchaseSeats/events";

export const useSPEventRemoveConfirmModal = createState({
  isOpen: false,
  eventsToRemove: [] as EventType[],
});
export function SPEventRemoveConfirmModal() {
  const dispatch = useDispatch();
  const { isOpen, eventsToRemove, set } = useSPEventRemoveConfirmModal();
  const eventNames = eventsToRemove
    .map((evt) => evt.title.replace("vs. ", ""))
    .join(", ");

  const onConfirm = () => {
    set({ isOpen: false });
    const eventCodesToRemove = eventsToRemove.map((evt) => evt.eventCode);
    dispatch(eventsState.actions.removeEventMulti(eventCodesToRemove));
  };

  return (
    <NotificationModal
      titleIconVariant="warning"
      isOpen={isOpen}
      hideSecondaryButton
      onClose={() => onConfirm()}
      onClickPrimaryButton={() => onConfirm()}
      primaryButtonText="Confirm"
      title="Warning!"
      description={
        <Box>
          <Box>
            <Typography variant="body1">
              You are about to remove <b>{eventNames}</b> from your cart. Are
              you sure ?
            </Typography>
          </Box>
        </Box>
      }
    />
  );
}
